// extracted by mini-css-extract-plugin
export default {"tipsDialog":"writeTipsBanner_tipsDialog__izp8q","likeAnimation":"writeTipsBanner_likeAnimation__iXoIX"};